// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.checkbox {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
}

.checkbox_box {
  width: 18px;
  height: 18px;
  border: 2px solid #757575;
  border-radius: 3px;
  margin-right: 8px;
  position: relative;
}

.checkbox_box--checked {
  background-color: #4285f4;
  border-color: #4285f4;
}

.checkbox_box--checked::after {
  content: '';
  position: absolute;
  left: 6px;
  top: 2px;
  width: 5px;
  height: 10px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.checkbox_label {
  font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Checkbox/Checkbox.css"],"names":[],"mappings":";AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB","sourcesContent":["\n.checkbox {\n  display: flex;\n  align-items: center;\n  margin-bottom: 8px;\n  cursor: pointer;\n}\n\n.checkbox_box {\n  width: 18px;\n  height: 18px;\n  border: 2px solid #757575;\n  border-radius: 3px;\n  margin-right: 8px;\n  position: relative;\n}\n\n.checkbox_box--checked {\n  background-color: #4285f4;\n  border-color: #4285f4;\n}\n\n.checkbox_box--checked::after {\n  content: '';\n  position: absolute;\n  left: 6px;\n  top: 2px;\n  width: 5px;\n  height: 10px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.checkbox_label {\n  font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
